import { fetchPostJSON } from "@util/api/helpers";

export const redirectToPortal = async (user) => {
    try {
        const { url, error } = await fetchPostJSON('/api/user/portal', {user});
        window.open(url, '_ blank');
    } catch (error) {
        if (error) return console.log((error).message);
    }
};